import BaseColors from '@/atoms/colors/Base';
import Typography from '@/components/Typography';
import HeadingSize from './HeadingSize';

const Heading = ({
  children,
  color,
  variant = 'h4',
  overrideStyles = {},
  sx,
  ...props
}) => {
  const sizeProps = HeadingSize[variant];
  const headingColor = BaseColors.font[color];

  return (
    <Typography
      {...props}
      variant={variant}
      color={headingColor}
      fontWeight={400}
      my={0}
      sx={{
        ...sizeProps,
        ...overrideStyles,
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
};

export default Heading;
